import clsx from "clsx";
import { PropsWithChildren } from "react";
import { LinkButtonProps } from "../LinkButton/types";
import { LinkButton } from "../LinkButton";
import { ButtonType } from "nvs-design-system/dist/Button_DEPRECATED/types";

type TabButtonProps = Omit<
  LinkButtonProps,
  "buttonStyle" | "icon" | "buttonType"
> & {
  isSelected?: boolean;
};

export function TabLink({
  className,
  isSelected,
  ...props
}: PropsWithChildren<TabButtonProps>) {
  return (
    <LinkButton
      className={clsx(className, { "is-selected": isSelected })}
      buttonType={ButtonType.tab}
      {...props}
    >
      {props.children}
    </LinkButton>
  );
}
